module.exports = __webpack_public_path__ + "files/denain.378072bdd23421a6a927607ebfec9ce3.pdf";